import { stayInfo, stayEstimate, minDeparture, eur, frDate } from "../lib/stay";

const inp = "w-full mt-2 px-4 py-3 bg-[#F5F3ED] border border-[#E5E1D8] rounded-md focus:outline-none focus:border-[#8C6C50]";
const lbl = "text-xs tracking-[0.2em] uppercase font-semibold text-[#666]";

export const StaySummary = ({ r }) => {
  const est = r.estimates || {};
  const names = Object.fromEntries((r.listings || []).map((l) => [l.id, l.title]));
  const ids = Object.keys(est);
  return (
    <>
      {r.departure_date ? (
        <>
          <span>Séjour : <strong>du {frDate(r.arrival_date)} au {frDate(r.departure_date)}</strong></span>
          <span>Durée : <strong>{r.nights} nuits ({r.duration_months} mois)</strong> · base {r.price_tier === "3m" ? "3 mois" : "1 mois"}</span>
        </>
      ) : (
        <>
          <span>Arrivée : <strong>{frDate(r.arrival_date)}</strong></span>
          <span>Durée : <strong>{r.duration_months} mois</strong></span>
        </>
      )}
      {ids.map((id) => (
        <span key={id} data-testid={`stay-total-${r.id}-${id}`}>
          Total estimé{ids.length > 1 ? ` (${names[id] || id})` : ""} : <strong>{eur(est[id].total)}</strong>
        </span>
      ))}
    </>
  );
};

export const StayFields = ({ form, setForm, listings, minMonths = 1, testid = "reservation" }) => {
  const stay = stayInfo(form.arrival_date, form.departure_date);
  const minDep = minDeparture(form.arrival_date, minMonths);
  const setArrival = (v) => setForm((f) => ({ ...f, arrival_date: v, departure_date: f.departure_date && f.departure_date >= minDeparture(v, minMonths) ? f.departure_date : "" }));
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className={lbl}>Arrivée</label>
          <input type="date" required min={new Date().toISOString().slice(0, 10)} value={form.arrival_date} onChange={(e) => setArrival(e.target.value)} className={inp} data-testid={`${testid}-arrival-date`} />
        </div>
        <div>
          <label className={lbl}>Départ</label>
          <input type="date" required disabled={!form.arrival_date} min={minDep} value={form.departure_date} onChange={(e) => setForm((f) => ({ ...f, departure_date: e.target.value }))} className={`${inp} disabled:opacity-50`} data-testid={`${testid}-departure-date`} />
        </div>
      </div>
      {form.arrival_date && <p className="text-xs text-[#666] -mt-2">Séjour de {Math.max(1, minMonths)} mois minimum (départ à partir du {minDep.split("-").reverse().join("/")}).</p>}
      {stay && (
        <div className="bg-[#F5F3ED] border border-[#E5E1D8] rounded-md p-4" data-testid={`${testid}-estimate`}>
          <div className="text-xs tracking-[0.15em] uppercase font-semibold text-[#8C6C50]">Simulation du séjour</div>
          <div className="text-sm text-[#2B3029] mt-1">{stay.nights} nuits · {stay.months} mois · base tarif {stay.tier === "3m" ? "3 mois" : "1 mois"}</div>
          <ul className="mt-2 space-y-1">
            {listings.map((l) => {
              const e = stayEstimate(l, stay);
              return (
                <li key={l.id} className="flex items-baseline justify-between gap-3 text-sm" data-testid={`${testid}-estimate-${l.id}`}>
                  {listings.length > 1 && <span className="truncate text-[#666]">{l.title}</span>}
                  {e ? (
                    <span className="ml-auto text-right"><strong className="font-serif text-xl text-[#1A1A1A]">{eur(e.total)}</strong> <span className="text-xs text-[#666]">({stay.nights} × {e.night.toFixed(2)} €)</span></span>
                  ) : <span className="ml-auto text-xs text-[#666]">Tarif sur demande</span>}
                </li>
              );
            })}
          </ul>
          <p className="text-[11px] text-[#666] mt-2">Estimation indicative, confirmée par la résidence.</p>
        </div>
      )}
    </div>
  );
};
